import { ref, computed } from 'vue';
import axios from 'axios';

export interface DeployInfo {
  branch: string;
  sha: string;
  deployedAt: string;
}

const deployInfo = ref<DeployInfo | null>(null);
const isLoaded = ref(false);

export function useDeployInfo() {
  async function load() {
    if (isLoaded.value) return;
    try {
      const { data } = await axios.get<DeployInfo>('/api/deploy-info');
      deployInfo.value = data;
    } catch {
      deployInfo.value = null;
    }
    isLoaded.value = true;
  }

  const isDevBranch = computed(() => deployInfo.value?.branch === 'dev');

  return { deployInfo, isDevBranch, load };
}
